import { formatCurrency } from '@/lib/format.js';

type ItemTileProps = {
  title: string;
  subtitle?: string | null;
  price?: number | string | null;
  badge?: string | null;
  disabled?: boolean;
  icon?: string;
  onClick?: () => void;
};

export function ItemTile({ title, subtitle, price, badge, disabled, icon, onClick }: ItemTileProps) {
  return (
    <button
      type="button"
      disabled={disabled}
      onClick={onClick}
      className={[
        'flex min-h-[108px] flex-col rounded-xl border border-slate-200 bg-white p-3 text-left shadow-sm transition',
        disabled
          ? 'cursor-not-allowed opacity-60'
          : 'hover:border-primary hover:bg-primary/5 active:scale-[0.98]',
      ].join(' ')}
    >
      {icon ? <span className="mb-1 text-2xl">{icon}</span> : null}
      <span className="line-clamp-2 text-sm font-semibold text-slate-950">{title}</span>
      {subtitle ? <span className="mt-0.5 line-clamp-1 text-xs text-slate-500">{subtitle}</span> : null}
      <div className="mt-auto flex items-center justify-between gap-2 pt-2">
        {price != null ? (
          <span className="text-sm font-bold text-slate-900">{formatCurrency(price)}</span>
        ) : (
          <span />
        )}
        {badge ? (
          <span className="rounded-full bg-red-100 px-2 py-0.5 text-[10px] font-bold uppercase text-red-700">
            {badge}
          </span>
        ) : null}
      </div>
    </button>
  );
}
